import { css } from '@emotion/react';
import { colors } from '../../global';

export const ButtonDanger = css`
    color: ${colors.white};
    background: ${colors.dandelionCrustaGradient};
`;
